import script from "./LeaderProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectForm.vue?vue&type=style&index=0&id=657d97e3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657d97e3"]])

export default __exports__